import { render, staticRenderFns } from "./ModalMenuDownload.vue?vue&type=template&id=0b486951&"
import script from "./ModalMenuDownload.vue?vue&type=script&lang=js&"
export * from "./ModalMenuDownload.vue?vue&type=script&lang=js&"
import style0 from "./ModalMenuDownload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Checkbox: require('/home/runner/work/myody_front/myody_front/components/checkbox/Checkbox.vue').default,FormItem: require('/home/runner/work/myody_front/myody_front/components/form/FormItem.vue').default,Form: require('/home/runner/work/myody_front/myody_front/components/form/Form.vue').default})
